import type { ConfigMetaData } from '@core/services/meta-custom.service';

import { LangEnum } from '@wizbii/utils/models';

type IMetadata = Record<string, ConfigMetaData>;

export const metadata: IMetadata = {
  home: {
    title: $localize`:@@metadata.home.title:WIZBII Money - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.home.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
  helps: {
    title: $localize`:@@metadata.helps.title:WIZBII Money - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.helps.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
  blog: {
    title: $localize`:@@metadata.blog.title:WIZBII Money - Actualités et conseils des aides financières françaises`,
    description: $localize`:@@metadata.blog.description:Toutes vos aides financières : retrouvez rapidement l\`ensemble des aides auxquelles vous avez droit ainsi que les conseils et dernières actualités des aides financières en France `,
    image: ``,
  },
  summary: {
    title: $localize`:@@metadata.summary.title:WIZBII Money - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.summary.description:Aide financière étudiante : Retrouvez rapidement les aides auxquelles vous avez droit. Un questionnaire simple et pratique qui regroupe de nombreuses aides nationales et régionales`,
    image: ``,
  },
  dashboard: {
    title: $localize`:@@metadata.dashboard.title:WIZBII Money - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.dashboard.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
  help_player: {
    title: $localize`:@@metadata.player.title:WIZBII Money - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.player.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
  landing: {
    title: $localize`:@@metadata.landing.title:WIZBII Money - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.landing.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
};

export const ogImageByLang: Partial<Record<LangEnum, string>> = {
  [LangEnum.fr]:
    'https://imaginary.wizbii.com/resize?nocrop=true&type=auto&url=https://storage.googleapis.com/wizbii-images/money-intl/home/og-image-fr.png&width=1200',
  [LangEnum.it]:
    'https://imaginary.wizbii.com/resize?nocrop=true&type=auto&url=https://storage.googleapis.com/wizbii-images/money-intl/home/og-img-it.png&width=1200',
  [LangEnum.es]:
    'https://imaginary.wizbii.com/resize?nocrop=true&type=auto&url=https://storage.googleapis.com/wizbii-images/money-intl/home/og-image-es.png&width=1200',
};
